import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";
import stringifyParams from "@/utils/stringifyParams";

const useAssignmentGet = (id, queryParams = {}) => {
  let resource = `${API_BASE_URL}/api/v3/assignment/${id}/`;
  const queryString = stringifyParams(queryParams);
  resource = `${resource}${queryString}`;
  return useRestQuery(resource, { skip: !id });
};

export default useAssignmentGet;
